import React from "react";
import { Tabs, Typography } from "antd";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { StyledTabs, StyledParagraph, StyledCollapse, StyledPanel } from "./style";

const { TabPane } = Tabs;
const { Title } = Typography;

const FAQcollapse = () => {
  const { currentUser } = useLoginContext();
  const isCompany = isCompanyUser(currentUser);

  return (
    <StyledTabs defaultActiveKey={isCompany ? "2" : "1"}>
      <TabPane tab={<Title level={5}>For bedrifter</Title>} key="2">
        <StyledCollapse accordion bordered={false} style={{ backgroundColor: "white" }}>
          <StyledPanel header="Hva blir formatet på KarriereDagene NTNU 2024?" key="1">
            <StyledParagraph>
              I år vil karrieremessen foregå fysisk i en messehall på Gløshaugen campus der bedrifter kan stille med
              stands og bedriftsrepresentanter. Messehallen vil romme standene fra de deltakende bedriftene, og elever
              kan fritt bevege seg for å snakke med bedriftsrepresentanter fra de ulike bedriftene.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hva koster det å delta på KarriereDagene NTNU?" key="2">
            <StyledParagraph>
              Kontakt oss direkte på <a href="mailto:kd@bindeleddet.no"> kd@bindeleddet.no </a> for informasjon om
              priser og tilbud for din bedrift.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvor er messehallen?" key="3">
            <StyledParagraph>
              Messehallen ligger midt på campus Gløshaugen, på plenen mellom Hovedbygningen, Gamle Elektro, Gamle Kjemi
              og Kjelhuset. Dette er et sentralt område som mange elever går forbi flere ganger i løpet av en dag.
              Adressen til Kjelhuset (Kolbjørn Hejes vei 1E) er et fint referansepunkt å gi til taxisjåføren eller legge
              inn i GPS-en. Dersom dere kommer med flybussen, passer det fint å gå av på Studentersamfundet. Herfra er
              det gangavstand til campus, men dersom dere har mye å bære kan dere bestille taxi eller ta buss 5 retning
              Dragvoll/Lohove fra busstoppet på nordsiden av Samfundet. Tar dere buss, går dere av på Gløshaugen syd.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Stand-essentials" key="4">
            <StyledParagraph>
              Standplassene i messehallen er 4x3 meter, og dere kan stå med fire representanter fra bedriften på
              standplassen. Det er god plass til roll-ups, stand-vegg og annet stand-materiale som brukes for å sette
              deres preg på standen.{" "}
              <p>
                {" "}
                <p> </p>
                Gjennom oss kan dere få ett ståbord, to barkrakker, to stoler, et lite bord og to glassboller. Dere har
                registrert eventuelle ønsker om dette i det nevnte logistikkskjemaet. Dette vil også bli gjennomgått
                sammen med dere over telefon før arrangementet, og det vil da være mulig å gjøre endringer.
              </p>
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="TV på stand" key="5">
            <StyledParagraph>
              Dersom dere ønsker å ha TV på deres stand kan dette bestilles via oss. Dersom dere ønsker å benytte dere
              av dette tilbudet skal ønske registreres i logistikkskjemaet. Da vil TV-en stå klar på standen når dere
              kommer. Merk at vi benytter en ekstern leverandør til dette, og det medfører dermed en ekstra kostnad.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Stand-tips" key="6">
            <StyledParagraph>
              <strong>Disse tipsene er for stand i messehall.</strong>
              <p> </p>
              <p>
                1. Vær åpen, tilgjengelig, kontaktsøkende og engasjert. Vi vil gjøre det lettest mulig for bedrifter og
                studenter å komme i kontakt. Terskelen senkes mye dersom man utstråler godt humør og engasjement og
                søker kontakt med studentene. Følg gjerne opp studentene dere har snakket med. Ved å for eksempel dele
                ut visittkort til studenter som viser seg som interessante, kan dere gjøre et ekstra inntrykk på dem.
              </p>{" "}
              <p>
                2. Ha innsikt i deres egen rekruttering. Ingen kjenner deres bedrift bedre enn dere! Vi tviler derfor
                ikke på at dere selger deres muligheter, verdier og miljø bedre enn alle andre. Mange studenter kommer
                også til å lure på detaljer rundt rekrutteringsprosessen, og vi anbefaler derfor alle representantene på
                stand å sette seg inn i dette på forhånd.
              </p>{" "}
              <p>
                3. Ha bredde i ansiennitet og roller. Bruk de fire plassene godt! Studentene vil gjerne møte nyansatte,
                men også ansatte med lengre fartstid i bedriften. Ansatte fra ulike avdelinger eller ansvarsområder er
                også bra for å vise frem de ulike mulighetene som finnes i bedriften.
              </p>{" "}
              <p>
                4. Del gjerne ut flyers, penner, små gadgets eller andre giveaways. La oss være ærlige – studenter
                elsker freebies. Ta gjerne med noe spennende! En innbydende flyer er også fin å dele ut etter en samtale
                med en student.
              </p>{" "}
              <p>
                5. Bruk standplassen deres godt. Konkurranser, utfordringer eller showcasing av ny teknologi eller nye
                løsninger dere har utviklet er en sikker vinner for å trekke studenter. Dersom dere er i tvil om noe vil
                få plass eller passe inn i messehallen kan dere gjerne ta kontakt med oss, og vi strekker oss langt for
                å tilrettelegge for det dere måtte ønske. Nederst på forsiden finner dere noen bilder av minneverdige
                stands opp gjennom årene.
              </p>
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Tilgang på strøm og internett" key="7">
            <StyledParagraph>
              Alle standplassene har tilgang på strøm. Dere kan derfor lade det som må lades, og plugge i eventuelt
              elektronisk utstyr som skal være en del av standen. Det er også tilgang på Wi-Fi i messehallen.
              Påloggingsinformasjonen får dere av deres hovedansvarlig.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Sending og rigging av stand" key="8">
            <StyledParagraph>
              Uken før KarriereDagene vil dere bli kontaktet av en hovedansvarlig fra KarriereDagene-teamet. Om dere
              ønsker å sende standen til oss kan dere sende den til vårt kontor med den hovedansvarlige som mottaker.
              <p> </p>{" "}
              <p>
                Adresser standen til: <strong>Bindeleddet NTNU Kolbjørn Hejes vei 1E NO - 7034 Trondheim </strong>
              </p>{" "}
              <p>
                Vi hjelper dere også med å rigge opp og ned standen. Det er mange medlemmer i KarriereDagene-teamet i
                messehallen som hjelper dere med begge deler.
              </p>{" "}
              <p>
                Vi tilbyr i utgangspunktet ikke å returnere stander for bedrifter. Har dere behov for hjelp eller
                spørsmål rundt returnering av stand, ta kontakt med deres hovedansvarlig.
              </p>
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvordan faktureres dere?" key="9">
            <StyledParagraph>
              Dere vil motta en faktura i etterkant av arrangementet, i løpet av oktober. Dere har fylt inn
              fakturainformasjonen deres i logistikkskjemaet, og denne vil bli dobbeltsjekket når dere blir oppringt av
              deres hovedansvarlige.
            </StyledParagraph>
          </StyledPanel>
          <StyledPanel header="Hvordan markedsfører vi deres deltagelse?" key="10">
            <StyledParagraph>
              Markedsføringen av KarriereDagene trappes opp fra studiestart, og toppes i ukene før arrangementet. Vi
              står på stand, henger opp plakater, blester i forelesninger og markedsfører i sosiale medier og på
              nettsidene våre. Når det gjelder hver enkelt bedrift, vil deres logo være synlig på plakater på campus
              rundt om i Trondheim, og på roll-ups på våre stands. I tillegg vil dere være synlig på nettsidene våre,
              gjennom vår oversikt over deltakende bedrifter. Her kan studenter klikke seg inn og få informasjon om
              deres bedrift og deltakelse på KarriereDagene. Teksten de leser, er den dere sende inn via
              logistikkskjemaet.
            </StyledParagraph>
          </StyledPanel>
        </StyledCollapse>
      </TabPane>
    </StyledTabs>
  );
};

export default FAQcollapse;
